import { Attributes } from 'interfaces/attribute.interface';
import { defaultAttribute } from '../static';
import { findKeyIndAttribute } from './FindKeyIndexAttribute';

export function DefineUserAttributesData(modifiedAttributes: Attributes[]): Attributes[] {
  const newAttributes: Attributes[] = [];
  for (const originalObj of defaultAttribute) {
    const appCode = Object.keys(originalObj)[0];
    const index = findKeyIndAttribute(modifiedAttributes, appCode);
    if (index === -1) {
      newAttributes.push(originalObj);
    } else {
      newAttributes.push(modifiedAttributes[index]);
    }
  }
  return newAttributes;
}
